import { createFileRoute } from '@tanstack/react-router';

import { ReportCataloguePage } from '@/features/reports/reports-pages';

export const Route = createFileRoute('/_app/projects/$projectId/reports/')({
  component: ReportsRoute,
});

function ReportsRoute() {
  const { projectId } = Route.useParams();
  return <ReportCataloguePage scope={{ kind: 'project', id: projectId }} />;
}
